import $ from 'jquery'
import Visibility from 'visibilityjs'

let windowVisible = true
export const isWindowVisible = () => windowVisible

export function init() {
  Visibility.change((e, state) => (windowVisible = state === 'visible'))
}

const $window = $(window)

export function isElementVisible(elem, overscan = 0) {
  if (elem instanceof $) elem = elem[0]
  const rect = elem.getBoundingClientRect()
  const windowHeight = $window.height()
  const windowWidth = $window.width()
  const overscanHeight = windowHeight * overscan
  return (
    rect.bottom + overscanHeight >= 0 &&
    rect.top - overscanHeight <= windowHeight &&
    rect.right >= 0 &&
    rect.left <= windowWidth
  )
}
